/**
 * @file Album highlight reducer.
 */

import {
  TOGGLE_IDENTITY,
  SET_IDENTITY,
  UPDATE_FILTER,
  SET_ENTITY,
  CLEAR_IDENTITIES,
} from '../actions/highlights';
import { ALBUM_HIGHLIGHTS_FILTER } from '../constants/albums';

export const initialState = {
  identities: [],
  entity: null,
  filter: {
    favoriteFilter: ALBUM_HIGHLIGHTS_FILTER.ALL,
    ratingFilter: undefined,
  },
};

const albumHighlightReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TOGGLE_IDENTITY:
      if (state.identities.includes(action.identityId)) {
        return {
          ...state,
          identities: state.identities.filter(id => id !== action.identityId),
        };
      }

      return { ...state, identities: [...state.identities, action.identityId] };

    case SET_ENTITY:
      return { ...initialState, entity: action.entity };

    case SET_IDENTITY:
      return { ...state, identities: [action.identityId] };

    case CLEAR_IDENTITIES:
      return { ...state, identities: [] };

    case UPDATE_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.filter,
        },
      };

    default:
      return state;
  }
};

export default albumHighlightReducer;
